/**
 * Implements news links.
 */
var Links = function( popup ) {
	jQuery( "a.iportal-news-popup-link, .iportal-news-popup-link > a" ).on(
		'click',
		function( event ) {
			event.preventDefault();
			popup.open();
		}
	);
};

export default Links;